import {safeDefineElement} from "@/scripts/core/global";
import {PaginateButton} from "@/scripts/optional/pagination-button";

safeDefineElement(PaginateButton)
